import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';

@Injectable()
export class AppSettings {

  static build: string = '818';
  static version: string = '6.15.2 b1';

  static isLoadTest: boolean = false;
  static isWebApp: boolean = true;
  static ipAPI: string = 'https://pro.ip-api.com/json/?key=aud05HLKWhsItuT';

  static currentYear: number = new Date().getFullYear();

  static bankingLbl: string = 'Payment Settings';

  public static tabletRez = 1200;
  public static mobileRez = 800;

  public static get gtmId() { return environment.gtmId; }
  public static get hubURL() { return environment.hubURL; }
  public static get apiURL() { return environment.apiURL; }
  public static get clientUrl() { return environment.clientUrl; }
  public static get webUrl() { return environment.webUrl; }
  public static get rrUrl() { return environment.rrUrl; }
  public static get rrApiUrl() { return environment.rrApiUrl; }
  public static get cbsDashUrl() { return environment.cbsDashUrl; }
  public static get cbsClientRootUrl() { return environment.cbsClientRootUrl; }
  public static get isProduction() { return environment.production; }
}
